const BASE_URL = "https://careers.kraitech.co.ke/api";
// const BASE_URL = "http://localhost:8000/api";

export const API_URLS = {
  auth: {
    login: `${BASE_URL}/auth/login`,
    logout: `${BASE_URL}/auth/logout`,
  },

  admin: {
    createEnumerator: `${BASE_URL}/admin/enumerators`,
    listEnumerators: `${BASE_URL}/admin/list-of-enumerators`,
    deleteEnumerator: (id) => `${BASE_URL}/admin/enumerators/${id}`,
    editEnumerator: (id) => `${BASE_URL}/admin/enumerators/${id}`,
    createSurvey: `${BASE_URL}/admin/surveys`,
    listSurveys: `${BASE_URL}/surveys`,
    getSurvey: (id) => `${BASE_URL}/surveys/${id}`,
    editSurvey: (id) => `${BASE_URL}/admin/surveys/${id}`,
    deleteSurvey: (id) => `${BASE_URL}/admin/surveys/${id}`,
    activeSurvey: `${BASE_URL}/surveys/active`,
    addQuestion: (id) => `${BASE_URL}/admin/surveys/${id}/questions`,
    editQuestion: (questionId) => `${BASE_URL}/admin/questions/${questionId}`,
    deleteQuestion: (questionId) => `${BASE_URL}/admin/questions/${questionId}`,
    surveyQuestions: (id) => `${BASE_URL}/admin/surveys/${id}/questions`,
    surveyResponses: (surveyId) => `${BASE_URL}/admin/surveys/${surveyId}/responses`,
    getResponse: (responseId) => `${BASE_URL}/responses/${responseId}`,
    updateResponse: (responseId) => `${BASE_URL}/responses/${responseId}`,
    deleteResponse: (responseId) => `${BASE_URL}/responses/${responseId}`,
    getAnswers: (responseId) => `${BASE_URL}/responses/${responseId}/answers`,
    updateAnswer: (answerId) => `${BASE_URL}/answers/${answerId}`,
    deleteAnswer: (answerId) => `${BASE_URL}/answers/${answerId}`,
    createRegion: `${BASE_URL}/admin/regions`,
    getRegions: `${BASE_URL}/admin/regions`,
    deleteRegion: (id) => `${BASE_URL}/admin/regions/${id}`,
    assignUser: `${BASE_URL}/admin/regions/assign-user`,
    unassignedUsers: `${BASE_URL}/admin/regions/unassigned-users`,
    dashboard: `${BASE_URL}/admin/dashboard`,
    quickStats: `${BASE_URL}/admin/dashboard/quick-stats`,
    enumeratorDetails: (id) => `${BASE_URL}/admin/dashboard/enumerator/${id}`,
    uploadDocument: `${BASE_URL}/admin/info-documents`,
    getDocuments: `${BASE_URL}/admin/info-documents`,
    deleteDocument: (id) => `${BASE_URL}/admin/info-documents/${id}`,
  },
};

const apiRequest = async (url, method = "GET", body = null, token = null) => {
  const headers = {
    "Content-Type": "application/json",
    Accept: "application/json",
  };

  const authToken = token || localStorage.getItem("accessToken");
  if (authToken) {
    headers["Authorization"] = `Bearer ${authToken}`;
  }

  const options = {
    method,
    headers,
  };

  if (body) {
    options.body = JSON.stringify(body);
  }

  const response = await fetch(url, options);
  const data = await response.json();

  if (!response.ok) {
    if (response.status === 401) {
      localStorage.removeItem("accessToken");
      localStorage.removeItem("user");
      if (window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
    }
    throw new Error(data.message || "Something went wrong");
  }

  return data;
};

export default apiRequest;